export default __webpack_public_path__ + "0d28cc51a736792f6ef2b560acb50023.svg";